import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  FetchBillingsDocument,
  CreateBillingMutation,
  CreateBillingMutationVariables,
  CreateBillingDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";

export default function useCreateBillingMutationHook(): { createBillingMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [createBillingMutation, { loading, error }] = useMutation<CreateBillingMutation, CreateBillingMutationVariables>(
    CreateBillingDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "billing-created-success",
          data: {
            title: t("toasts.billingcreatedsuccessfully"),
            type: "success"
          }
        });
      },
      refetchQueries: [
        {
          query: FetchBillingsDocument
        }
      ]
    });

  return {
    createBillingMutation,
    loading,
    error
  };
}
